<form #searchForm="ngForm" (ngSubmit)="submitSearch()">
  <div class="search-box">
    <input
      [(ngModel)]="searchText"
      [placeholder]="placeholder"
      (keyup)="onKeyUp($event)"
      (search)="search()"
      searchbox="ngForm"
      type="search"
      name="searchText"
      class="ep-input ep-text-regular-16"
      required
    />
    <button type="submit" class="ep-btn ep-btn-compact search-button" [disabled]="!searchForm.form.valid">
      <app-svg-icon class="icon-info" src="./assets/icons/arrow-right.svg"></app-svg-icon>
    </button>
  </div>
</form>
